import * as React from 'react';
import { Divider, Form, Grid, Header, Icon, Input, Message, Segment } from 'semantic-ui-react';

import { Description, Field } from 'src/componentes/semantic-ui-extended';

interface Props {
    cargando: boolean;
    mensajeDeError?: string;
    usuario: string;
    contraseña1: string;
    contraseña2: string;
    alCambiarTexto(campo: string, valor: string): void;
    alPresionarBoton(): void;
}

const PrimerCambioDeContraseña: React.FunctionComponent<Props> = props => {
    const {
        cargando,
        mensajeDeError,
        usuario,
        contraseña1,
        contraseña2,
        alCambiarTexto,
        alPresionarBoton,
    } = props;

    const error = !!mensajeDeError;

    return (
        <div style={{ height: '100vh' }}>
            <Grid textAlign='center' verticalAlign='middle' style={{ height: '100%' }}>
                <Grid.Column style={{ maxWidth: '400px' }}>
                    <Header as='h2'>Bienvenido</Header>

                    <Form size='large' error={error} onSubmit={alPresionarBoton}>
                        <Segment textAlign='left' stacked>
                            <Message icon style={{ fontSize: '11pt' }}>
                                <Icon name='privacy' color='blue' />
                                Por tu seguridad debes cambiar la contraseña antes de continuar.
                            </Message>

                            <Description>
                                La contraseña debe tener un mínimo de 8 caracteres y tener al menos
                                una letra mayúscula y una letra minúscula. Si colocas números y
                                símbolos mucho mejor.
                            </Description>

                            <input readOnly autoComplete='username' value={usuario} hidden />

                            <Field
                                label='Cree una contraseña'
                                disabled={cargando}
                                error={error}
                                required
                            >
                                <Input
                                    type='password'
                                    autoComplete='new-password'
                                    autoFocus
                                    fluid
                                    disabled={cargando}
                                    error={error}
                                    value={contraseña1}
                                    onChange={(_e, { value }) => {
                                        alCambiarTexto('contraseña1', value);
                                    }}
                                />
                            </Field>

                            <Field
                                label='Confirme la contraseña'
                                disabled={cargando}
                                error={error}
                                required
                            >
                                <Input
                                    type='password'
                                    autoComplete='new-password'
                                    fluid
                                    disabled={cargando}
                                    error={error}
                                    value={contraseña2}
                                    onChange={(_e, { value }) => {
                                        alCambiarTexto('contraseña2', value);
                                    }}
                                />
                            </Field>

                            <Divider hidden />

                            <Form.Button
                                fluid
                                type='submit'
                                color='blue'
                                size='large'
                                loading={cargando}
                                content='Cambiar mi contraseña'
                            />

                            <Message error content={mensajeDeError} />
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        </div>
    );
};

export default PrimerCambioDeContraseña;



// WEBPACK FOOTER //
// ./src/paginas/Login/paginas/PrimerCambioDeContraseña/componentes/PrimerCambioFormulario.tsx